import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { Carousel } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import * as styles from "./carouselTestimonials.module.css";

const CarouselTestimonials = () => {
  const data = useStaticQuery(graphql`
    query {
      Uzziel: file(relativePath: { eq: "Uzziel-02.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Margot: file(relativePath: { eq: "Margot-02.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Diana: file(relativePath: { eq: "Diana.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Manuel: file(relativePath: { eq: "Manuel.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Nicole: file(relativePath: { eq: "Nicole.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      Gabriel: file(relativePath: { eq: "Gabriel-02.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className={styles.carousel}>
      <div className={"secondary-headings"} style={{ textAlign: "center" }}>
        Esto es lo que dicen nuestros usuarios.
      </div>
      <Carousel interval={5000} indicators={false} controls={false}>
        <Carousel.Item>
          <Container className={styles.carouselContainer}>
            <Row>
              <Col md={2} xs={4} className={styles.containerQuote}>
                <Img fluid={data.Margot.childImageSharp.fluid} />
              </Col>
              <Col md={4} xs={8} className={styles.containerQuote}>
                <div className={"general-text"}>
                  “Súper Satisfecha. Está muy padre y fácil de utilizar, sin
                  tantos requisitos o garantías. El equipo de soporte es de los
                  mejores, resuelven todas tus dudas casi al instante!! Hasta
                  hoy para mi es de las mejores.”
                </div>
                <div className={"general-text"}>MARGOT</div>
              </Col>
              <Col md={2} xs={4} className={styles.removeTestimonial}>
                <Img fluid={data.Manuel.childImageSharp.fluid} />
              </Col>
              <Col md={4} xs={8} className={styles.removeTestimonial}>
                <div className={"general-text"}>
                  “Mi historial en el buró no es tan bueno. Casham me dio
                  crédito y mi calificación empieza a mejorar.”
                </div>
                <div className={"general-text"}>MANUEL – Empleado</div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
        <Carousel.Item>
          <Container className={styles.carouselContainer}>
            <Row>
              <Col md={2} xs={4} className={styles.containerQuote}>
                <Img fluid={data.Uzziel.childImageSharp.fluid} />
              </Col>
              <Col md={4} xs={8} className={styles.containerQuote}>
                <div className={"general-text"}>
                  “Súper encantado con la aplicación.”
                </div>
                <div className={"general-text"}>UZZIEL</div>
              </Col>
              <Col md={2} className={styles.removeTestimonial}>
                <Img fluid={data.Diana.childImageSharp.fluid} />
              </Col>
              <Col md={4} className={styles.removeTestimonial}>
                <div className={"general-text"}>
                  “Casham me permitió obtener un crédito a mi nombre sin la
                  ayuda de mis papás. Estoy construyendo mi historial y espero
                  pronto poder hacerme de mi propia tarjeta de crédito.”
                </div>
                <div className={"general-text"}>DIANA – Estudiante</div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
        <Carousel.Item>
          <Container className={styles.carouselContainer}>
            <Row>
              <Col md={2} xs={4} className={styles.containerQuote}>
                <Img fluid={data.Gabriel.childImageSharp.fluid} />
              </Col>
              <Col md={4} xs={8} className={styles.containerQuote}>
                <div className={"general-text"}>
                  “Excelente y una respuesta pronta!!”
                </div>
                <div className={"general-text"}>GABO</div>
              </Col>
              <Col md={2} xs={4} className={styles.removeTestimonial}>
                <Img fluid={data.Nicole.childImageSharp.fluid} />
              </Col>
              <Col md={4} xs={8} className={styles.removeTestimonial}>
                <div className={"general-text"}>
                  “Casham me prestó cuando NADIE me había aprobado. La
                  suscripción es lo mejor que he hecho por mí :-).”
                </div>
                <div className={"general-text"}>NICOLE – Estudiante</div>
              </Col>
            </Row>
          </Container>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default CarouselTestimonials;
